import { render, staticRenderFns } from "./BanConfirmation.vue?vue&type=template&id=7e033264&scoped=true"
import script from "./BanConfirmation.vue?vue&type=script&lang=js"
export * from "./BanConfirmation.vue?vue&type=script&lang=js"
import style0 from "./BanConfirmation.vue?vue&type=style&index=0&id=7e033264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e033264",
  null
  
)

export default component.exports